import React from "react";
import PlusIconOnCircle from '../../../icons/PlusIconOnCircle';

const PlusIconComponent = ({ onClick }) => (
  <div className="cursor-pointer d-flex justify-content-center flex-column">
    <span className="text-center"><span className="edge-top" /></span>
    <span className="text-center" style={{ marginTop: '-7px' }} onClick={onClick}>
      <PlusIconOnCircle className="fill-blue-main w-20 h-20" />
    </span>
  </div>
);

export default PlusIconComponent;
